import type { IJwt } from '~/entities/auth'
import { useAccountStore, useAuth } from '~/entities/auth'
import { useUserMeLazyQuery } from '~/shared/api'
import { decodeJwt } from '~/shared/lib'

export default defineNuxtPlugin(async () => {
  const {
    isAuthenticated,
    accessToken,
    ensureValidAccessToken,
    shouldRequirePinUnlock,
  } = useAuth()
  const { data: account } = storeToRefs(useAccountStore())

  async function loadAccount() {
    if (!isAuthenticated.value) {
      return
    }

    if (shouldRequirePinUnlock()) {
      return
    }

    const isValid = await ensureValidAccessToken()

    if (!isValid || !accessToken.value) {
      return
    }

    const jwtResult = decodeJwt<IJwt>(accessToken.value)
    account.value.roles = jwtResult?.realm_access.roles ?? []

    try {
      const data = await useUserMeLazyQuery().load()

      if (data) {
        account.value.id = data.me.id
        account.value.firstName = data.me.firstName
        account.value.lastName = data.me.lastName
        account.value.middleName = data.me.patronymic
      }
    }
    catch (error) {
      console.error('[storeInit] failed to load user', error)
    }
  }

  await loadAccount()

  watch(isAuthenticated, async (value, previousValue) => {
    if (value && !previousValue) {
      await loadAccount()
    }
  })
})
